<!-- generic popup for big jobs (like loading a project, especially) -->
<div id="hang-on" class="fdm-dialog">
  <mat-card class="fdm-dropdown-panel">
    <mat-card-header class="header" style="background-color:#333;">
      <div class="subheading-2 title">{{ 'GENERIC.WORKING_MSG' | translate }}</div>
      <div class="header-actions">
        <button mat-icon-button (click)="hideHangOn()"><fa-icon class="fdm-icon" icon="times"></fa-icon></button>
      </div>
    </mat-card-header>
    <mat-card-content style="height:80px;">
      <div class="fdm-section fdm-centered" style="padding:20px 40%;">
        <div id="hang-on-msg" style="font-size: 30px;color:#777;position:absolute;margin: 25px;">{{ msg }}</div>
        <mat-spinner color="accent" diameter="50"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</div>

